const Input = ({ value, placeholder, type, id, name, onChange }) => {
  return (
    <div className="flex flex-col gap-2 w-full">
      {type !== "file" && (
        <label
          className="text-[10px] font-black text-gray-500 ml-1 uppercase tracking-[0.15em]"
          htmlFor={id}
        >
          {placeholder}
        </label>
      )}
      <input
        className={`input-field ${type === "file" ? "bg-transparent border-dashed border-2 border-white/10" : ""}`}
        value={value}
        placeholder={type === "file" ? placeholder : `e.g. ${placeholder}`}
        type={type}
        id={id}
        name={name}
        onChange={onChange}
      />
    </div>
  );
};

export default Input;
